import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActiveProgramManager } from '../components/ActiveProgramManager';
import { PremiumPage } from '../components/premium';
import { api } from '../lib/api';
import type { SavedPlanListRow } from '../coachTypes';
import type { UserProfile } from '../types';

export function WorkoutProgramPage() {
  const nav = useNavigate();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [savedPlanRows, setSavedPlanRows] = useState<SavedPlanListRow[]>([]);

  const reload = useCallback(async () => {
    const prof = await api<UserProfile | null>('/api/profile');
    setProfile(prof);
    const rows = await api<SavedPlanListRow[]>('/api/saved-workout-plans').catch(() => []);
    setSavedPlanRows(rows);
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  async function setActivePlanId(planId: string) {
    await api<UserProfile | null>('/api/profile/active-program', {
      method: 'PATCH',
      body: JSON.stringify({ planId: planId || null }),
    });
    await reload();
  }

  return (
    <PremiumPage title="Programs" onBack={() => nav('/workouts')} backLabel="Back to Train">
      <ActiveProgramManager
        savedPlanRows={savedPlanRows}
        activePlanId={profile?.activeSavedWorkoutPlanId}
        onActivePlanChange={setActivePlanId}
        onSaved={() => void reload()}
      />
    </PremiumPage>
  );
}
